<template>
    <div class="app-main">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
        </el-row>
        <el-row class="mg-b5">
            <el-card class="box-card">
                <div class="switch-mian">
                    <el-form label-width="150px" ref="form" :model="form" :rules="rules" size="small">
                        <el-form-item label="价格审批是否线上审批:" prop="auditSwitch">
                            <el-switch
                                :disabled="loading"
                                v-model="form.auditSwitch"
                                active-color="#13ce66"
                                @change="editSwitch"
                                inactive-color="#eee">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="是否能提前开标:" prop="canAheadKb">
                            <el-switch
                                :disabled="loading"
                                v-model="form.canAheadKb"
                                active-color="#13ce66"
                                @change="editSwitchb"
                                inactive-color="#eee">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </el-row>
    </div>
</template>
<script>
    import { getSystemConfig,switchEdit } from '@/api/system/switch.js'
    export default {
        data() {
            return {
                loading:false,
                form:{
                    id:null,
                    auditSwitch:true,
                    canAheadKb:true,
                },
                rules:{

                }
            }
        },
        created(){
            this.getSwitch()
        },
        methods:{
            async getSwitch(){
                let _this = this;
                _this.loading = true;
				const {
					data: res
                } = await getSystemConfig({})
                console.log(res.data.onlineAudit)
				if (res.code == 0) {
                    _this.form.auditSwitch = res.data.onlineAudit == '是';
                    _this.form.canAheadKb = res.data.canAheadKb == '是';
                    _this.form.id = res.data.id;
				} else {
                }
                _this.loading = false;
            },
            async editSwitch (bool) {
                console.log(bool)
                let _this = this;
                _this.loading = true;
                const {
					data: res
                } = await switchEdit({
                    id:_this.form.id,
                    onlineAudit:bool?'是':'否'
                })
                if(res.code == 0){
                    _this.$success('修改成功')
                }
                _this.getSwitch()
            },
            async editSwitchb (bool) {
                console.log(bool)
                let _this = this;
                _this.loading = true;
                const {
					data: res
                } = await switchEdit({
                    id:_this.form.id,
                    canAheadKb:bool?'是':'否'
                })
                if(res.code == 0){
                    _this.$success('修改成功')
                }
                _this.getSwitch()
            }
        }
    }
</script>
<style scoped="scoped"  lang="scss">
.switch-mian{
    height: calc(100vh - 130px);
}
</style>
